export default {
  mobileLanding: {
    media: {
      appPreview: "Animierte App-Vorschau",
      leagues: "Liga-Auswahlbildschirm",
      trendFlow: "Animierter Trend-Flow",
      trendAnalysis: "Detailbildschirm der Trend-Analyse",
      myPicks: "Meine Tipps Bildschirm",
      checkout: "Checkout-Bildschirm",
    },
    sections: {
      research: {
        heading: "Von der Recherche zur Wette in Sekunden",
        body: "Linemate übernimmt die Recherche für dich und analysiert Trends und Matchups, damit du ohne stundenlanges Suchen von Insight zu Wette kommst.",
      },
      leagues: {
        body: "Wähle aus über 18 großen Ligen und entdecke Trends und Plays, die auf die Spiele und Spieler zugeschnitten sind, die dir am wichtigsten sind.",
      },
      trends: {
        body: "Durchsuche Top-Trends und wähle ein Play, das durch echte Daten, aktuelle Leistung und relevanten Kontext gestützt wird.",
      },
      analysis: {
        body: "Tauche tiefer in jedes Play ein mit klaren Aufschlüsselungen zu Leistung, situativem Kontext und den wichtigsten Signalen hinter dem Trend.",
      },
      odds: {
        body: "Finde die besten verfügbaren Quoten bei verschiedenen Anbietern und hole den meisten Value aus jeder Wette.",
      },
      checkout: {
        body: "Schließe in Sekunden ab, während dein Betslip bei deinem bevorzugten Anbieter automatisch ausgefüllt wird.",
      },
    },
    cta: {
      titleLineOne: "Dein Zuhause",
      titleLineTwo: "für jede Wette",
    },
  },
};
